var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseFloatingButton',{on:{"click":_vm.emitClickEvent}},[_c('HintImage')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }